import React, { useEffect, useState } from 'react'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {Alert, Container, Typography,
    IconButton, InputAdornment, Grid, Link, Checkbox, 
    FormControlLabel, TextField, CssBaseline, Button, Avatar, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import BarLogin from '../Screen/BarLogin';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  root: {
    flex: 1,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center'
  },
  avatar: {
    margin: '1rem',
  },
  form: {
    width: '100%',
  },
  submit: {
    margin: '3rem',
    padding: '1.5rem',
  },
  checkboxLabel: {
      fontSize: 12
  }
}));

function Login() {
const classes = useStyles();
  const [email, setEmail] = React.useState('');
  const [blocked, setBlocked] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [show, setShow] = React.useState(false);
  const [remember, setRemember] = useState(false);
  const history = useNavigate()
  const [fails, setFails] = useState(0)

  useEffect(() => {
    if (localStorage.checkbox && localStorage.email !== "") {
      setRemember(true);
      setEmail(localStorage.username)
    }
   }, [])
   const generatePassword = (len) => {
    let result = [];
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@-%$#!&+?';
    const charLength = characters.length;
    for (let i = 0; i < len; i++) {
        result.push(characters.charAt(Math.floor(Math.random() * charLength)));
    }
    return result.join('');
}
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password) {
          return setBlocked("Passwords is required")
        } 

        if (!email) {
            return setBlocked('Username is required');
        } 
        try {
          if (remember !== false) {
            localStorage.username = email.trim();
            localStorage.password = password;
            localStorage.checkbox = remember;
          } 
           if(fails!=3){
             db.collection("users")
        .where("id", "==", email.toLowerCase())
        .where("password","==",password).get()
        .then(function(querySnapshot) {
            if (!querySnapshot.empty) {
               let otp = generatePassword(5);
                             db.collection('users').doc(email.toLowerCase()).get().then(function(snapshot) {
                 var templateParams = {
                    email: snapshot.data().email,
                    subject: 'Two Factor Authentication',
                    message: 'OTP: '+ otp,
                    comp_name: 'Dev Arena'
                   
                 };
         emailjs.send("service_oiqb0bo","template_ntw8bxg",templateParams,"wwlXdyG0epB_-bxgu")
            .then(function(response) {
                db.collection('users').doc(email.toLowerCase()).update({
                code: otp,
                logedin: true
              });
                history('/2fa/'+email.toLowerCase())
            }, function(error) {
              console.log(error)
            }); 
               })
            }
            else {
              setBlocked("Username or Password is incorrect!")
               setFails(fails+1)
            }
        });
           }
           else
           {
              setBlocked("Please reset your password")
           }
        
          } catch(e) {
            console.log(e)
            setBlocked("Error! Login Failed")
          }
  }

  const handleClickShowPassword = () => {
    setShow(!show);
  };

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };
  return (
    <div>
    <BarLogin/>
         <Container component="main" maxWidth="xs" className="card" style={{padding:'1rem'}}>
            <CssBaseline />
            <Paper className={classes.paper} style={{padding:'2rem'}}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h4">
                    Login
                </Typography>
                
                <form className={classes.form} noValidate>
                {blocked ? (
                    <Alert onClose={() => {setBlocked('')}} severity="error">
                       {blocked} 
                    </Alert>
                ) : null}
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Username"
                        autoFocus
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type={show ? 'text' : 'password'}
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        InputProps={{
                          endAdornment: (
                              <InputAdornment position="end">
                                  <IconButton
                                      aria-label="toggle password visibility"
                                      onClick={handleClickShowPassword}
                                      onMouseDown={handleMouseDownPassword}
                                  >
                                      {show ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                              </InputAdornment>
                          )
                      }}
                    />  
                    <Grid container alignItems="center">
                        <Grid item xs>
                        <FormControlLabel
                            className={classes.checkboxLabel}
                            control={<Checkbox value="remember" color="primary"  checked={remember} 
            onChange={(e)=>{setRemember(e.target.checked)}}/>}
                            label="Remember me"
                            //si
                        />
                        </Grid>
                        <Grid item>
                        <Link href="/forgot" variant="body1">
                            Forgot password?
                        </Link>
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classes.submit}
                        onClick={handleSubmit}>
                        Login
                    </Button>
                </form>
            </Paper>
        </Container>
    </div>
  )
}

export default Login